import React, { useEffect, useState } from 'react';
import FormattedDateTime from '../../common/datetime/FormattedDateTime';
import { ApiWebhookRequest, ApiWebhookRequestStatus } from '../../api';
import { WebhookRequestModal } from './WebhookRequestModal';
import { webhookRequestApi } from '../../apis';
import { retryRequest } from './webhookRequestActions';
import { Button, SalvIconButton } from '@salvapp/ui-components';
import LoadMoreTable from '../../table/LoadMoreTable';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { useDispatch } from 'react-redux';

export const WebhookRequests = () => {
  const size = 20;
  const [total, setTotal] = useState(0);
  const [requests, setRequests] = useState<ApiWebhookRequest[]>([]);
  const [fetching, setFetching] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [request, setWebhookRequestDetails] = useState<ApiWebhookRequest | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    fetch(0, size).then((requests) => {
      setRequests(requests.content);
      setTotal(requests.total);
      setFetching(false);
    });
  }, [fetching]);

  const fetch = async (page: number, size: number) =>
    await webhookRequestApi.findWebhookRequests({
      page,
      size,
    });

  const showWebhookRequestDetails = async (request: ApiWebhookRequest) => {
    setWebhookRequestDetails(request);
    setShowModal(true);
  };

  const closeModal = async () => {
    setShowModal(false);
    setWebhookRequestDetails(null);
    setFetching(true);
  };

  const scheduleWebhookRequestRetry = async (webhookRequestId: number | undefined) => {
    if (!webhookRequestId) {
      return;
    }
    await dispatch(retryRequest(webhookRequestId));
    await closeModal();
  };

  return (
    <>
      {!fetching && (
        <LoadMoreTable
          title={'Webhook requests'}
          total={total}
          page={0}
          size={size}
          initialItems={requests}
          fetchPage={(page, size) => fetch(page, size).then((requests) => requests.content)}
          titleActions={
            <Button variant='white' size='small' onClick={() => setFetching(true)}>
              <i className='fe fe-refresh-cw'> </i>
            </Button>
          }
          showLoadMoreUntilNoDataToFetch={true}
          striped={true}
          header={() => (
            <tr>
              <th>Time</th>
              <th>Status</th>
              <th>Url</th>
              <th>Trigger</th>
              <th>Duration</th>
              <th>Response Status</th>
              <th></th>
            </tr>
          )}
          body={(webhookRequests) =>
            webhookRequests.map((request) => (
              <tr key={request.id}>
                {request.retryTime ? (
                  <td>
                    <FormattedDateTime date={request.retryTime} showTime />
                  </td>
                ) : (
                  <td>
                    <FormattedDateTime date={request.createdTime} showTime />
                  </td>
                )}
                <td
                  className={
                    request.status === ApiWebhookRequestStatus.FAILED
                      ? 'text-danger'
                      : request.status === ApiWebhookRequestStatus.COMPLETED
                        ? 'text-success'
                        : ''
                  }
                >
                  {request.status}
                </td>
                <td>{request.url}</td>
                <td>{request.trigger}</td>
                <td>{request.executionDuration != null && request.executionDuration + ' ms'}</td>
                <td>{request.responseStatus}</td>
                <td>
                  <SalvIconButton
                    variant='secondary'
                    icon={faCircleInfo}
                    ariaLabel={'Details'}
                    onClick={() => showWebhookRequestDetails(request)}
                  />
                </td>
              </tr>
            ))
          }
        />
      )}
      <WebhookRequestModal
        show={showModal}
        request={request}
        onComplete={closeModal}
        scheduleRetry={scheduleWebhookRequestRetry}
      />
    </>
  );
};

export default WebhookRequests;
